// extracted by mini-css-extract-plugin
export default {"column__host-container":"styles_column__host-container__8Svac","column__host-name":"styles_column__host-name__lqoLp","column__host-brand":"styles_column__host-brand__2PF+f"};